export const RATIO_MIN = 1;
export const RATIO_MAX = 99;

export const createIntegerRules = (label, { required = true, min = 0, max } = {}) => {
  const rangeText = max === undefined ? '非负整数' : `${min}～${max} 的整数`;
  return [
    ...(required ? [{ required: true, message: `请输入${label}` }] : []),
    { type: 'number', min, max, message: `${label}必须为${rangeText}` },
    {
      validator: (_, value) => {
        if (value === undefined || value === null || Number.isInteger(value)) {
          return Promise.resolve();
        }
        return Promise.reject(new Error(`${label}必须为整数`));
      },
    },
  ];
};

export const createEndValueRule =
  (startName, label) =>
  ({ getFieldValue }) => ({
    validator(_, value) {
      const startValue = getFieldValue(startName);
      if (
        value === undefined ||
        value === null ||
        startValue === undefined ||
        value >= startValue
      ) {
        return Promise.resolve();
      }
      return Promise.reject(new Error(`${label}不得小于起始值`));
    },
  });
